import TooltipWidget from '../../lib/Tooltip/Tooltip';

import {TextField} from '@deere/fuel-react';
import React from 'react';

const InputWidget = ({
  label,
  type,
  required,
  id,
  value,
  setValue,
  customError,
  error,
  helperText,
  infoIconText,
  multiline,
  minRows,
}) => {
  const [err, setErr] = React.useState(false);
  const handleErr = () => {
    error ? setErr(true) : setErr(false);
  };
  const handleErr_lagecy = () => {
    if (error) {
      setErr(false);
    } else {
      setErr(true);
    }
  };
  return (
    <TextField
      required={required}
      type={type}
      id={id}
      label={
        <>
          <span>{label}</span>
          {infoIconText && (
            <TooltipWidget
              tooltip={infoIconText}
              placement="right"
            ></TooltipWidget>
          )}
        </>
      }
      fullWidth={true}
      size="small"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      error={err}
      helperText={err && helperText}
      onBlur={customError ? handleErr_lagecy : handleErr}
      multiline={multiline}
      minRows={minRows}
      role="textbox"
    />
  );
};
export default InputWidget;
